import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-esa-alert-register-dialog',
  templateUrl: './esa-tentou-register-dialog.component.html',
  styleUrls: ['./esa-tentou-register-dialog.component.scss']
})
export class EsaTentouRegisterDialogComponent implements OnInit {
  modal = true;
  constructor() { }

  /**
   *
   */
  ngOnInit(): void {
  }
}
